import React from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { TableFooter, Button } from '@material-ui/core';
import './UserList.scss'
import * as moment from 'moment'

import UserActionButtonGroup from './UserActionButtonGroup'

export default function UserList(props) {
    let userList = null;

    if (props.userList) {
        userList = props.userList.map((item, key) => {
            return <TableRow key={item.id}>
                <TableCell component="th" scope="row">{item.fullname}</TableCell>
                <TableCell align="center">{item.mobilePhoneNumber}</TableCell>
                <TableCell align="center">{item.email}</TableCell>
                {/* <TableCell align="center">{key}</TableCell> */}
                <TableCell align="center">{item.paymentStatus ? 'Paid' : (!item.paymentStatus && item.hasRefunded == true ? 'Refunded': 'Not Paid')}</TableCell>
                <TableCell align="center">{item.language}</TableCell>
                <TableCell align="center">{moment(item.createdAt).isValid() ? moment.utc(item.createdAt).local().format("DD/MM/YYYY hh:mm:ss A") : ''}</TableCell>
                <TableCell align="center">
                    <UserActionButtonGroup adminGroup={props.adminGroup} className="userlist-action-button" id={item.id} {...props}/>
                </TableCell>
            </TableRow>
        });
    }

    return (
        <React.Fragment>
            <div className="userlist-table-wrapper admin-result-table">
                <Table className="userlist-table">
                    <TableHead>
                        <TableRow>
                            <TableCell>Full Name</TableCell>
                            <TableCell align="center">Mobile Number</TableCell>
                            <TableCell align="center">Email</TableCell>
                            <TableCell align="center">Payment Status</TableCell>
                            <TableCell align="center">Language</TableCell>
                            <TableCell align="center"><Button onClick={props.triggerJoinDateSort} className="table-asc-desc-button">Join Date<img className="table-asc-desc-icon" src="/assets/img/table-ascending-descending-icon.png" alt="Icon"/></Button></TableCell>
                            <TableCell align="center">Actions</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {userList}
                    </TableBody>
                </Table>
            </div>
            {
                props.haveNextPage ? <Table>
                    <TableFooter>
                        <TableRow>
                            <TableCell align="center">
                                <Button onClick={props.loadMore} disabled={props.isLoading} className="grey-btn--small" color="primary">Load More</Button>
                            </TableCell>
                        </TableRow>
                    </TableFooter>
                </Table> : null
            }
        </React.Fragment>
    )
}